import {
  CLOSE_SECURITY_INFO_CREATE_POPUP,
  GET_SECURITY_INFOS_FULFILLED,
  SecurityInfoActionTypes,
  SecurityInfoState,
  OPEN_SECURITY_INFO_CREATE_POPUP,
  CREATE_SECURITY_INFO_FULFILLED,
  SET_SECURITY_INFO_LOADING,
} from './securityInfo.types';

export const initialState: SecurityInfoState = {
  entities: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function securityInfoReducer(
  state = initialState,
  action: SecurityInfoActionTypes,
): SecurityInfoState {
  switch (action.type) {
    case GET_SECURITY_INFOS_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data || [],
      };

    case CREATE_SECURITY_INFO_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case OPEN_SECURITY_INFO_CREATE_POPUP:
      return {
        ...state,
        single: action.payload.securityInfo ?? null,
        createdId: null,
        ui: {
          ...state.ui,
          isCreatePopupOpen: true,
        },
      };

    case CLOSE_SECURITY_INFO_CREATE_POPUP:
      return {
        ...state,
        ui: {
          ...state.ui,
          isCreatePopupOpen: false,
        },
      };

    case SET_SECURITY_INFO_LOADING:
      return {
        ...state,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
